<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row >
        <b-col class="mb-2">
          <b-form-select class="mb-2" v-model="selected_product" :options="products"></b-form-select>
          <b-form-select v-model="selected_client_customer"
                         v-if="selected_product"
                         @change="getDashboard(selected_product, selected_client_customer)"
                         :options="client_customers"></b-form-select>

        </b-col>

      </b-row>

      <b-row>


        <b-col sm="12" lg="6" class="d-flex">
          <b-card no-body class="flex-fill" v-if="selected_client_customer" >
            <b-card-body class="pb-0">
              <h2 class="mb-0">{{arrivalsTotalSum | decimal}} Kg</h2>
              <p>Total recibido</p>
            </b-card-body>
            <card-line1-chart-example v-if="arrivals.by_day" chartId="card-chart-01" class="chart-wrapper px-2 align-top" style="max-height:70px;"
                                      :data="arrivals.by_day" :height="70"/>
            <b-list-group flush>
              <b-list-group-item v-for="item in arrivals.by_product_type" class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <p class="mb-0">{{item.product_type}} : {{item.quantity | integer }} Un - {{item.net_kilograms |
                    decimal }} Kg</p>
                  <small>{{item.product}}</small>
                </div>
              </b-list-group-item>
            </b-list-group>
            <div class="flex-fill"></div>
          </b-card>
        </b-col>


        <b-col sm="12" lg="6" class="d-flex">
          <b-card no-body class="flex-fill" v-if="selected_client_customer" >
            <b-card-body class="pb-0">
              <h2 class="mb-0">{{process.process_totals.sum_net_kilograms | decimal }} Kg</h2>
              <p>Total procesado</p>
            </b-card-body>
            <process-stacked-bar-chart v-if="process.last_5_process_days"
                                       class="chart-wrapper px-2"
                                       :avg_net_kilograms_day="process.process_totals.avg_net_kilograms_day"
                                       :max_net_kilograms_day="process.process_totals.max_net_kilograms_day"
                                       :data="process.last_5_process_days"></process-stacked-bar-chart>
          </b-card>
        </b-col>


      </b-row>
      <b-row>

        <b-col sm="12" lg="6" class="d-flex">
          <b-card class="flex-fill" no-body v-if="selected_client_customer">
            <b-card-body class="pb-0">
              <h2 class="mb-0">{{stockTotalSum | decimal }} Kg</h2>
              <p>Total en Stock</p>
            </b-card-body>
            <b-list-group flush>
              <b-list-group-item v-for="item in groupedStocks">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-0">Stock {{item.product_type}} : {{item.quantity | integer }} Un - {{item.net_kilograms |
                    decimal }} Kg</h5>
                  <small>{{item.product}}</small>
                </div>
                <ul>
                  <li v-for="subitem in item.details"> {{subitem.container}}: {{subitem.pallets}} Pallets
                    {{subitem.type}} <span v-if="subitem.exportable">({{subitem.sum_quantity | integer }} Cajas)</span>
                  </li>
                </ul>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>

        <b-col sm="12" lg="6" class="d-flex">
          <b-card class="flex-fill" no-body  v-if="selected_client_customer" >
            <b-card-body class="pb-0">
              <h2 class="mb-1">{{exportTotalSum | decimal}} Kg</h2>
              <p>Total Exportado</p>
            </b-card-body>
              <b-table fixed hover :fields="fields" :items="exportations.slice(0,10)">
                <template v-slot:cell(country)="data">
                  <i v-b-tooltip.hover :title="data.item.country" :class="countryFlag(data.item.alpha2_code)"></i>
                </template>
                <template v-slot:cell(net_kilograms)="data">
                  <p>{{data.value | decimal}}</p>
                </template>
                <template v-slot:cell(consignee)="data">
                  <p>{{data.value}}</p>
                </template>
              </b-table>
          </b-card>
        </b-col>



<!--        <b-col sm="12" lg="6">-->
<!--          <b-card no-body v-if="selected_client_customer">-->
<!--            <b-card-body class="pb-0">-->
<!--              <h2 class="mb-0">Calidad</h2>-->
<!--              <p>Porcentajes de recepción de fruta</p>-->
<!--            </b-card-body>-->
<!--            <qc-pie-chart :data="quality"></qc-pie-chart>-->
<!--          </b-card>-->
<!--        </b-col>-->


      </b-row>
    </div>
  </div>
</template>

<script>
  import numeral from 'numeral';
  import locales from 'numeral/locales'
  numeral.locale('es');
  import _ from 'lodash';
  import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
  import MainChartExample from './dashboard/MainChartExample'
  import ProcessStackedBarChart from './dashboard/ProcessStackedBarChart'
  import QcPieChart from './dashboard/QcPieChart'


  export default {
    name: "Dashboard",
    components: {
      CardLine1ChartExample,
      MainChartExample,
      ProcessStackedBarChart,
      QcPieChart,
    },
    filters: {
      integer(value) {
        return numeral(parseInt(value)).format('0,0')
      },
      decimal(value) {
        return numeral(value).format('0,0.0')
      },
    },
    data() {
      return {
        products: [],
        client_customers: [],
        selected_product: null,
        selected_client_customer: null,
        stock: null,
        process: {
          last_5_process_days: null,
          process_totals: null,
        },
        arrivals: {
          by_day: null,
          by_product_type: null
        },
        quality: null,
        exportations: null,
        fields: [
          {
            key: 'net_kilograms',
            label: 'Total Exportado',
          },
          {
            key: 'consignee',
            label: 'Consignee',
          },
          {
            key: 'country',
            label: 'País',
          },

        ],
      }
    },
    methods: {
      countryFlag(code) {
        return "flag-icon flag-icon-"+code.toLowerCase()+" h3";
      },
      getCustomers() {
        this.$axios.get ('/production/get_customers/')
          .then(res => {
            const data = res.data.data;
            const customers = [];
            for (let key in data) {
              const customer = data[key];
              customers.push(customer)
            }
            this.client_customers = customers
            this.client_customers.unshift({text: 'Seleccione Exportadora...', value: null})
          })
          .catch(error => console.log(error))
      },
      getProducts(){
        this.$axios.get ('/production/get_products/')
        .then(res => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for(let key in data){
            const product = data[key];
            products.push(product)
          }
          this.products = products
          this.products.unshift({text: 'Seleccione producto...', value: null})
        })
        .catch(error => console.log(errors))
      },
      getDashboard (product, client_customer) {
        this.$axios({
          method: 'get',
          url: '/production/dashboard/',
          params: {
            product: product,
            client_customer: client_customer,
          }
        })
          .then(res => {
            this.stock = res.data.stock;
            this.arrivals = res.data.arrivals;
            this.process = res.data.process;
            this.quality = res.data.quality;
            this.exportations = res.data.exportations;
          })
          .catch(error => {
            console.log(error)
          });
      }
    },
    computed: {

      arrivalsTotalSum () {
        return _.sumBy(this.arrivals.by_product_type, 'net_kilograms')
      },
      stockTotalSum () {
        return _.sumBy(this.stock, 'sum_net_kilograms')
      },
      exportTotalSum(){
        return _.sumBy(this.exportations, 'net_kilograms')
      },

      groupedStocks() {
        return _(this.stock)
          .groupBy('name')
          .map((name, id) => ({
            product_type: id,
            quantity: _.sumBy(name, 'sum_quantity'),
            net_kilograms: _.sumBy(name, 'sum_net_kilograms'),
            product: name[0].product,
            details: name
          }))

          .value()
      },
    },
    created() {
      this.getProducts();
      this.getCustomers();
    }
  }
</script>

<style>
  .main .container-fluid {
    padding: 0 10px;
  }

</style>
